// src/data/coupons.js
export const couponsData = [
  {
    id: "donki",
    name: "唐吉軻德 (Don Quijote)",
    desc: "免稅 10% + 最高 7% OFF",
    note: "請點擊開啟網頁版優惠券，結帳時出示給店員點擊。",
    // image: "/coupons/donki.png", // 這裡圖片可以放 LOGO 示意即可，不需要條碼圖
    color: "#000000", // 唐吉軻德黑色質感，或用經典黃色 #FEF200
    url: "https://japanportal.donki-global.com/coupon/cp001_zhtw.html", // 重要：這是網頁版連結
    tiers: [
      "滿 30,000 日圓 (未稅)：享 7% OFF",
      "滿 10,000 ~ 29,999 日圓 (未稅)：享 5% OFF",
    ],
  },
  {
    id: "sugi",
    name: "SUGI 藥局 (スギ薬局)",
    desc: "最高 18% OFF (免稅10% + 折扣8%)",
    note: "日本高品質大型連鎖藥妝店",
    image: "/coupons/sugi.png",
    color: "#E60012",
    // 新增：折扣級距
    tiers: [
      "滿 10,000 ~ 29,999 日圓：享 4% 折扣",
      "滿 30,000 ~ 49,999 日圓：享 6% 折扣",
      "滿 50,000 日圓以上：享 8% 折扣",
    ],
  },
  {
    id: "matsumoto",
    name: "松本清 (マツモトキヨシ)",
    desc: "免稅 10% + 最高 7% OFF",
    note: "創業90年以上老舖，藥品與化妝品種類非常豐富！",
    image: "/coupons/matsumoto.png",
    color: "#FFF100",
    textColor: "black",
    tiers: [
      "滿 10,000 ~ 29,999 日圓：享 3% OFF",
      "滿 30,000 ~ 49,999 日圓：享 5% OFF",
      "滿 50,000 日圓以上：享 7% OFF",
    ],
  },
  {
    id: "sundrug",
    name: "SUNDRUG (尚都樂客)",
    desc: "免稅 10% + 最高 7% OFF",
    note: "在購物時出示優惠券就可以得到折扣。",
    image: "/coupons/sundrug.png", // 記得確認副檔名是 jpg 還是 png
    color: "#005CAB", // 品牌藍色
    tiers: [
      "滿 10,000 ~ 29,999 日圓：享 3% OFF",
      "滿 30,000 ~ 49,999 日圓：享 5% OFF",
      "滿 50,000 日圓以上：享 7% OFF",
    ],
  },
  {
    id: "satudora",
    name: "札幌藥妝 (サツドラ)",
    desc: "免稅 + 5% OFF",
    note: "北海道最有名的藥妝店",
    image: "/coupons/satudora.png",
    color: "#00A0E9",
    tiers: ["消費金額達免稅門檻即可享 5% OFF"],
  },
  {
    id: "cocokara",
    name: "Cocokara Fine",
    desc: "最高 7% OFF",
    note: "和松本清一樣的日本大手藥妝連鎖",
    image: "/coupons/cocokara.png",
    color: "#EA5514",
    tiers: [
      "滿 10,000 ~ 29,999 日圓：享 3% OFF",
      "滿 30,000 ~ 49,999 日圓：享 5% OFF",
      "滿 50,000 日圓以上：享 7% OFF",
    ],
  },
  {
    id: "biccamera",
    name: "Bic Camera (ビックカメラ)",
    desc: "免稅 10% + 最高 7% OFF",
    note: "難波店｜家電、藥妝、清酒皆有優惠",
    image: "/coupons/biccamera.png", // ⚠️ 請確認你的圖片檔名
    color: "#E60012", // Bic Camera 的經典紅色
    tiers: [
      "家電/相機/玩具/手錶/隱形眼鏡：享 7% OFF",
      "化妝品/藥品/日用品/食品：享 5% OFF",
      "日本清酒：享 3% OFF",
      "⚠️ 皆需消費滿 5,000 日圓以上 (未稅)",
    ],
    map: "https://maps.app.goo.gl/PFdo2AjeU5v2avhNA",
  },
];
